import { toast } from "react-toastify";
import { preserveAdminThemeDuringClear } from "../../utils/adminThemeStorage";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

// SIGNIN

function* signinUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Login, formData.payload);
    if (result.data.errors) {
      toast.error(result.data.errors[0]);
    } else {
      yield put(
        actions.loginUserSuccessAction({
          data: result.data,
        })
      );
      result.data.data.role[0].name == "Super Admin" &&
        window.location.replace("/dashboard/students");
      result.data.data.role[0].name == "Teacher" &&
        window.location.replace("/dashboard/students");
      result.data.data.role[0].name == "Student" &&
        window.location.replace("/students");
    }
  } catch (error) {
    toast.error(error.response.data.errors[0]);
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* signupUser(formData) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.signup, formData.payload);
    if (result.data.errors) {
      console.log(result.data.errors);
      toast.error(result.data.errors[0]);
    } else {
      formData?.action();
      yield put(
        actions.loginUserSuccessAction({
          data: result.data,
        })
      );
      toast.success("تم التسجيل وفي انتظار المواففة علي طلبك");
    }
  } catch (error) {
    // Fix error message so it doesn't show with commas between every character
    const errorMsg = error.response?.data?.message;
    if (typeof errorMsg === "string") {
      toast.error(errorMsg);
    } else if (typeof errorMsg === "object" && errorMsg !== null) {
      toast.error(Object.values(errorMsg).join(", "));
    } else {
      toast.error("حدث خطأ غير متوقع");
    }
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* signoutUser() {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    const result = yield call(api.Logout);
    yield put(actions.logoutUserSuccessAction());
    preserveAdminThemeDuringClear(() => window.localStorage.clear());

    window.location.href = "/login";
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

function* getAllYears() {
  try {
    // yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.years);
    yield put(actions.yearsSuccessAction(result.data));
  } catch (error) {
    toast.error(error);
    //console.log(error, 'error');
  } finally {
  }
}

function* getAllFaculties() {
  try {
    // yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.faculties);
    yield put(actions.facultiesSuccessAction(result.data));
  } catch (error) {
    toast.error(error);
    //console.log(error, 'error');
  } finally {
  }
}

function* getAllGovernorates() {
  try {
    const result = yield call(api.governorates);
    yield put(actions.governoratesSuccessAction(result.data));
  } catch (error) {
    toast.error(error);
  } finally {
  }
}

function* userVoucher({ payload }) {
  try {
    yield put(actions.setAuthIsLoadingAction(true));
    yield put(actions.userVoucherSuccessAction());
    payload?.action && payload?.action();
  } catch (error) {
    toast.error("طلبك  مرفوض");
  } finally {
    yield put(actions.setAuthIsLoadingAction(false));
  }
}

export default function* authSaga() {
  yield takeLatest(Types.LOGIN_USER, signinUser);
  yield takeLatest(Types.LOGOUT_USER, signoutUser);
  yield takeLatest(Types.USER_VOUCHER, userVoucher);
  yield takeLatest(Types.SIGNUP_USER, signupUser);
  yield takeLatest(Types.YEARS, getAllYears);
  yield takeLatest(Types.FACULTIES, getAllFaculties);
  yield takeLatest(Types.GOVERNORATES, getAllGovernorates);
}
